export const checkOut ={
    'en': 'check out sticker definitions',
    'zh-tw': '查閱表情主題與代號',
};
export const checkchatid ={
    'en': 'check out chat id . TOEN text:[TOKEN]',
    'zh-tw': '查閱聊天室id 你的權杖:[TOKEN]',
};

export const Token = {
    'en': 'token text [TOKEN]',
    'zh-tw': '權杖[TOKEN]',
};

export const SendMessage = {
    'en': 'send the message',
    'zh-tw': '送出訊息',
};

export const setsendtext ={
    'en': 'set send the message [TEXT]',
    'zh-tw': '設定送出訊息[TEXT]',
}

export const TokenNull ={
    'en': 'Token or Message is null',
    'zh-tw': '權杖或傳送訊息錯誤',
};

export const Sendsticker ={
    'en': 'set Send Package image[STICKER]',
    'zh-tw': '設定的送出表情圖[STICKER]',
};
export const chat_id ={
    'en': 'Chat ID: [ID] ',
    'zh-tw': '聊天室序號[ID]',
};
export const SendImageFile ={
    'en': 'send the image file[URL]',
    'zh-tw': '傳送圖片網址：[URL]',
}



